module.exports = __webpack_public_path__ + "static/media/brenda.2b826565.png";